<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { $, Alert, defineSchema } from '@bagelink/vue'
const schema = defineSchema({
	explanation: $.display(Alert, {
		info: true,
		thin: true,
		title: 'Inline content from the Popups collection',
		message: 'Choose a record whose Type is Inline. Its content will appear here as part of the page.',
	}),
	popupId: $.select('Inline content', inlinePopupOptions, {
		placeholder: inlinePopupOptions.length ? 'Choose inline content' : 'No inline content found',
		searchable: true,
	}),
})
export const BlockInlinePopup = defineBlock({
	thumbnail: '/block-thumbs/BlockPopup.svg',
	category: 'Content',
	order: 251,
	name: 'BlockInlinePopup',
	label: 'Inline Popup Content',
	icon: 'view_agenda',
	schema,
	defaults: { popupId: '' },
	dataSource: [{ collection: 'popups', store: 'the_torah', label: 'Popups' }],
})
</script>
<script setup lang="ts">
import { useBloxRuntime } from '@bagelink/blox'
import { Btn } from '@bagelink/vue'
import { computed } from 'vue'
import { useCollection } from '@/composables/useDatastore'
import { inlinePopupOptions } from './inlinePopupEditorOptions'
import RichHtml from '@/components/RichHtml.vue'

interface PopupRecord {
	id?: string
	_id?: string
	name?: string
	slug?: string
	type?: 'popup' | 'inline'
	buttonText?: string
	buttonLink?: string
	popupContent?: string
}



const props = defineProps<{ popupId?: string }>()
const { isPreview } = useBloxRuntime()
const { items, loading } = useCollection<PopupRecord>('popups', { limit: 100, all: true })

const selected = computed(() => items.value.find(item =>
	item.type === 'inline'
	&& (item.id === props.popupId || item._id === props.popupId || item.slug === props.popupId),
))

const showMissingSelection = computed(() =>
	isPreview.value && !loading.value && !selected.value,
)
</script>

<template>
	<section v-if="selected" class="w850px px-2 py-2 m_px-1 m_py-1-5">
		<RichHtml class="popup-text txt-center" :html="selected.popupContent" />
		<div v-if="selected.buttonText" class="txt-center pt-1">
			<Btn
				:href="selected.buttonLink || undefined"
				color="primary"
				:value="selected.buttonText"
			/>
		</div>
	</section>
	<Alert
		v-else-if="showMissingSelection"
		info
		thin
		title="Choose inline content"
		message="Select an Inline record from the Popups collection in the block settings."
		class="m-1"
	/>
</template>
